import UserCompanyPermissionModel, { IUserCompanyPermissionModel } from "../models/DTO/UserCompanyPermissionModel";
import ApiResponseModel from "../models/API/ApiResponseModel";
import * as reqAxios from "./HttpService";
import ApiEndpoints, { IUserCompanyPermissionControllerEndpoint } from "../configurations/ApiEndpoints";
import { CreateAuthHeader, CreateAuthToDeleteHeader } from "../configurations/DefaultAxiosConfig";
import ErrorModel, { IErrorModel } from "../models/DTO/ErrorModel";
import defaultAxios from "../configurations/DefaultAxiosConfig";
import { CancelToken } from "axios";
import { DencryptText, EncryptText } from "../Helpers/CryptoHelper";

const ApiPath = (): IUserCompanyPermissionControllerEndpoint => {
    const baseEndoint: IUserCompanyPermissionControllerEndpoint | undefined = new ApiEndpoints().UserCompanyPermission;

    if (!baseEndoint)
        throw new Error("User Company Permission endpoint could not be null.");

    return baseEndoint;
}

/** Not used yet, maybe remove in future */
export const GetAll = (token: string, callback: (userCompanyPermissions: IUserCompanyPermissionModel[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetAll}`, config, (response, error) => {
            const treatedResponse = reqAxios.HandleResponse<string>(response, error),
                result = HandlePermissionsResponse(treatedResponse);

            callback && callback(result, treatedResponse.Error);
        })
    }
}

export const GetUserCompanyPermissions = (token: string, callback: (userCompanyPermissions: IUserCompanyPermissionModel[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUserCompanyPermissions}`, config, (response, error) => {
            const treatedResponse = reqAxios.HandleResponse<string>(response, error),
                result = HandlePermissionsResponse(treatedResponse),
                { Messages, Error } = treatedResponse;

            callback && callback(result, Error);
        });
    }
}

export const GetPermissionsByCompany = (token: string, companyId: number, callback: (userCompanyPermissions: IUserCompanyPermissionModel[], message: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && companyId > 0) {

        const config = CreateAuthHeader("Bearer", token, cancelToken);
        reqAxios.Get(`${ApiPath().GetPermissionsByCompany}?companyId=${companyId}`, config, (response, error) => {
            const treatedResponse = reqAxios.HandleResponse<string>(response, error),
                result = HandlePermissionsResponse(treatedResponse),
                { Messages, Error } = treatedResponse;

            callback && callback(result, Messages, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const GetUserCompanyPermissionsAsync = async (token: string, cancelToken?: CancelToken): Promise<{ userCompanyPermissions: IUserCompanyPermissionModel[], error?: IErrorModel }> => {

    try {
        const url: string = `${ApiPath().GetUserCompanyPermissions}`,
            reqConfig = CreateAuthHeader("Bearer", token, cancelToken),
            apiResponse = await defaultAxios.get(url, reqConfig),
            api: ApiResponseModel = new ApiResponseModel(apiResponse),
            data = api && api.Data,
            decrypted = JSON.parse(DencryptText(data, process.env.REACT_APP_PERMISSION_KEY!)),
            userCompanyPermissions: IUserCompanyPermissionModel[] = (decrypted != null && decrypted.map((item: any) => new UserCompanyPermissionModel().LoadFromAPI(item))) || [],
            result = { userCompanyPermissions: userCompanyPermissions, error: undefined };

        return result;
    }
    catch (err: any) {
        const { request, response } = err,
            model = {
                userCompanyPermissions: [], error: new ErrorModel(response?.data, (request == null || request.status == 0) ? 500 : request.status)
            }

        return model;
    }

}

/** Not used yet, maybe remove in future */
export const GetUserCompanyPermissionById = (token: string, id: number, callback: (userCompanyPermission?: IUserCompanyPermissionModel, error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Get(`${ApiPath().GetUserCompanyPermissionById}?userCompanyPermissionId=${id}`, config, (response, error) => {
            const treatedResponse = reqAxios.HandleResponse<string>(response, error),
                result = HandlePermissionResponse(treatedResponse),
                { Messages, Error } = treatedResponse;

            callback && callback(result, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const GetUserCompanyPermissionByUserId = (token: string, userId: number, callback: (userCompanyPermissions: IUserCompanyPermissionModel[], message: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && userId > 0) {

        const config = CreateAuthHeader("Bearer", token, cancelToken);
        reqAxios.Get(`${ApiPath().GetUserCompanyPermissionByUserId}?userId=${userId}`, config, (response, error) => {
            const treatedResponse = reqAxios.HandleResponse<string>(response, error),
                result = HandlePermissionsResponse(treatedResponse),
                { Messages, Error } = treatedResponse;

            callback && callback(result, Messages, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const Create = (token: string, userCompanyPermission: IUserCompanyPermissionModel, callback?: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!userCompanyPermission)
            throw new Error("User Company Permission could not be null.");

        const formData = new FormData(),
            config = CreateAuthHeader("Bearer", token, cancelToken),
            boddy = JSON.stringify(userCompanyPermission.ToJson());

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        reqAxios.Post(`${ApiPath().Create}`, formData, config, (response, error) => {
            const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const CreateCollection = (token: string, collection: IUserCompanyPermissionModel[], callback?: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && collection != null && collection.some(x => x.Id == 0)) {

        const formData = new FormData(),
            config = CreateAuthHeader("Bearer", token, cancelToken),
            filtered = collection.filter(x => x.Id == 0),
            boddy = JSON.stringify([...filtered.map(p => JSON.parse(p.ToJson()))]);

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        if (filtered != null && filtered.some(x => x)) {
            reqAxios.Post(`${ApiPath().CreateCollection}`, formData, config, (response, error) => {
                const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

                callback && callback(IsSuccess, Messages, Error);
            });
        }
    }
}

/** Not used yet, maybe remove in future */
export const Update = (token: string, userCompanyPermission: IUserCompanyPermissionModel, callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!userCompanyPermission)
            throw new Error("User Company Permission could not be null.");

        const formData = new FormData(),
            config = CreateAuthHeader("Bearer", token, cancelToken),
            boddy = JSON.stringify(userCompanyPermission.ToJson());

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        reqAxios.Put(`${ApiPath().Update}?userCompanyPermissionId=${userCompanyPermission.Id}`, formData, config, (response, error) => {
            const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const UpdateCollection = (token: string, collection: IUserCompanyPermissionModel[], callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && collection != null && collection.some(x => x.Id > 0)) {

        const formData = new FormData(),
            config = CreateAuthHeader("Bearer", token, cancelToken),
            filtered = collection.filter(x => x.Id > 0),
            boddy = JSON.stringify([...filtered.map(p => JSON.parse(p.ToJson()))]);

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        if (filtered != null && filtered.some(x => x)) {
            reqAxios.Put(`${ApiPath().UpdateCollection}`, formData, config, (response, error) => {
                const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

                callback && callback(IsSuccess, Messages, Error);
            });
        }
    }
}

/** Not used yet, maybe remove in future */
export const Delete = (token: string, id: number, callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "") {

        if (!id || id == 0)
            throw Error("Id to delete an User Company Permission cannot be null or less then 1.");

        const config = CreateAuthHeader("Bearer", token, cancelToken);

        reqAxios.Delete(`${ApiPath().Delete}?userCompanyPermissionId=${id}`, config, (response, error) => {
            const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}

/** Not used yet, maybe remove in future */
export const DeleteCollection = (token: string, collection: IUserCompanyPermissionModel[], callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && collection != null && collection.some(x => x.Id > 0)) {

        const formData = new FormData(),
            filtered = collection.filter(x => x.Id > 0),
            boddy = JSON.stringify([...filtered.map(p => JSON.parse(p.ToJson()))]);

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        const config = CreateAuthToDeleteHeader("Bearer", token, formData, cancelToken)

        reqAxios.Delete(`${ApiPath().DeleteCollection}`, config, (response, error) => {
            const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

            callback && callback(IsSuccess, Messages, Error);
        });
    }
}

export const SetPermissions = (token: string, collection: IUserCompanyPermissionModel[], callback: (isSuccess: boolean, message?: string[], error?: IErrorModel) => void, cancelToken?: CancelToken): void => {
    if (token != null && token != "" && collection != null && collection.some(x => x)) {

        const formData = new FormData(),
            boddy = JSON.stringify([...collection.map(p => JSON.parse(p.ToJson()))]);

        formData.append("serializedDto", EncryptText(process.env.REACT_APP_PERMISSION_KEY!, boddy));

        const config = CreateAuthHeader("Bearer", token, cancelToken, formData)

        reqAxios.Post(`${ApiPath().SetUsersCompaniesPermissions}`, formData, config,
            (response, error) => {
                const { Messages, IsSuccess, Error } = reqAxios.HandleResponse(response, error);

                callback && callback(IsSuccess, Messages, Error);
            });
    }
}

export const HandlePermissionsResponse = <TResult extends IUserCompanyPermissionModel, TResponse extends string>(response: reqAxios.HandledResponseType<TResponse>): TResult[] => {
    const { Data: data } = response,
        decrypted = (data != null && data != "" && JSON.parse(DencryptText(data, process.env.REACT_APP_PERMISSION_KEY!)).map((item: any) => new UserCompanyPermissionModel().LoadFromAPI(item))) || [],
        result: TResult[] = (decrypted != null && decrypted) || [];

    return result;
}

export const HandlePermissionResponse = <TResult extends IUserCompanyPermissionModel, TResponse extends string>(response: reqAxios.HandledResponseType<TResponse>): TResult => {
    const { Data: data } = response,
        decrypted = (data != null && data != "" && new UserCompanyPermissionModel().LoadFromAPI(JSON.parse(DencryptText(data, process.env.REACT_APP_PERMISSION_KEY!)))),
        result = decrypted as TResult
    return result;
}